import React, { createContext, useContext } from 'react';

const Web3Context = createContext();

// Default stub values - wallet connection feature has been disabled
// Deposits now use manual TX hash entry instead of wallet connections
const defaultWeb3Value = {
  account: null,
  balance: '0',
  isConnected: false,
  isConnecting: false,
  canSendTransactions: false,
  connectedWallets: [],
  primaryWallet: null,
  balances: {},
  usdtBalance: '0',
  walletsLoaded: true,
  connect: async () => ({ success: false, error: 'Wallet connection disabled' }),
  disconnect: async () => {},
  disconnectAllWallets: () => {},
  setPrimaryWallet: () => {},
  refreshBalances: async () => {},
  sendEth: async () => { throw new Error('Wallet connection disabled'); },
  sendToken: async () => { throw new Error('Wallet connection disabled'); },
  sendTransaction: async () => { throw new Error('Wallet connection disabled'); },
  formatAddress: (addr) => addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : '',
  getBalance: () => '0',
};

export const useWeb3 = () => {
  const context = useContext(Web3Context);
  // Always return stub - wallet connection feature disabled
  return context || defaultWeb3Value;
};

// Stub provider that does nothing - kept for compatibility
export const Web3Provider = ({ children }) => {
  return (
    <Web3Context.Provider value={defaultWeb3Value}>
      {children}
    </Web3Context.Provider>
  );
};
